module.exports = __webpack_public_path__ + "static/media/logofull.f3d43f3b.png";